module.exports = __webpack_public_path__ + "img/ico_ck1.ee56b233.png";